/*!
 * jQuery throttle / debounce - v1.1 - 3/7/2010
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 * 
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */

// Script: jQuery throttle / debounce: Sometimes, less is more!
//
// *Version: 1.1, Last updated: 3/7/2010*
// 
// Project Home - http://benalman.com/projects/jquery-throttle-debounce-plugin/
// GitHub       - http://github.com/cowboy/jquery-throttle-debounce/
// Source       - http://github.com/cowboy/jquery-throttle-debounce/raw/master/jquery.ba-throttle-debounce.js
// (Minified)   - http://github.com/cowboy/jquery-throttle-debounce/raw/master/jquery.ba-throttle-debounce.min.js (0.7kb)
// 
// About: License
// 
// Copyright (c) 2010 "Cowboy" Ben Alman,
// Dual licensed under the MIT and GPL licenses.
// http://benalman.com/about/license/
// 
// About: Examples
// 
// These working examples, complete with fully commented code, illustrate a few
// ways in which this plugin can be used.
// 
// Throttle - http://benalman.com/code/projects/jquery-throttle-debounce/examples/throttle/
// Debounce - http://benalman.com/code/projects/jquery-throttle-debounce/examples/debounce/
// 
// About: Support and Testing
// 
// Information about what version or versions of jQuery this plugin has been
// tested with, what browsers it has been tested in, and where the unit tests
// reside (so you can test it yourself).
// 
// jQuery Versions - none, 1.3.2, 1.4.2
// Browsers Tested - Internet Explorer 6-8, Firefox 2-3.6, Safari 3-4, Chrome 4-5, Opera 9.6-10.1.
// Unit Tests      - http://benalman.com/code/projects/jquery-throttle-debounce/unit/
// 
// About: Release History
// 
// 1.1 - (3/7/2010) Fixed a bug in <jQuery.throttle> where trailing callbacks
//       executed later than they should. Reworked a fair amount of internal
//       logic as well.
// 1.0 - (3/6/2010) Initial release as a stand-alone project. Migrated over
//       from jquery-misc repo v0.4 to jquery-throttle repo v1.0, added the
//       no_trailing throttle parameter and debounce functionality.
// 
// Topic: Note for non-jQuery users
// 
// jQuery isn't actually required for this plugin, because nothing internal
// uses any jQuery methods or properties. jQuery is just used as a namespace
// under which these methods can exist.
// 
// Since jQuery isn't actually required for this plugin, if jQuery doesn't exist
// when this plugin is loaded, the method described below will be created in
// the `Cowboy` namespace. Usage will be exactly the same, but instead of
// $.method() or jQuery.method(), you'll need to use Cowboy.method().
// I minified it just to save me some scrolling time
!function(t,d){var u,n=t.jQuery||t.Cowboy||(t.Cowboy={});n.throttle=u=function(e,i,r,a){var c,f=0;function t(){var t=this,n=+new Date-f,o=arguments;function u(){f=+new Date,r.apply(t,o)}a&&!c&&u(),c&&clearTimeout(c),a===d&&e<n?u():!0!==i&&(c=setTimeout(a?function(){c=d}:u,a===d?e-n:e))}return"boolean"!=typeof i&&(a=r,r=i,i=d),n.guid&&(t.guid=r.guid=r.guid||n.guid++),t},n.debounce=function(t,n,o){return o===d?u(t,n,!1):u(t,o,!1!==n)}}(this);


/****************/
/****************/
// sticky header with announcement
/* function headerSize() {
  var $headerHeight = $('div#shopify-section-header').outerHeight();
  console.log($headerHeight);
  $('#PageContainer').css('padding-top', $headerHeight);
}

$(window).on("load", headerSize);
$(window).on("resize", $.debounce(500, headerSize));
*
  function equalTitleHeight() {
    var $el = '';
    var $elStringLength = 0;
    $(".product-card__title").each(function( index ) {
      if($( this ).text().length > $elStringLength) {
        $elStringLength = $( this ).text().length;
        $el = $( this );
      }
    });
    if($el != '') $('.product-card__title').css('height', $el.height()+'px');
  }


equalTitleHeight()
/****************/
/****************/
/****************/
// sticky header without announcement
$(window).on("load", function() {

  function enableScrollLock() {
    scrollPosition = window.pageYOffset;
    document.body.style.top = '-' + scrollPosition + 'px';
//     document.body.classList.add(classes.preventScrolling);
  }

  function disableScrollLock() {
//     document.body.classList.remove(classes.preventScrolling);
    document.body.style.removeProperty('top');
    window.scrollTo(0, scrollPosition);
  }
  
var $headerHeight = $('.site-header__mobile-nav').outerHeight();

//   $(window).on("load", headerSize);
//   $(window).on("resize", $.debounce(500, function() { console.log('debounce')}));
  let scroll = 100;

  $('.js-mobile-nav-toggle').click(function() {
    if ($(this).hasClass('mobile-nav--close')) {
//       $('body').addClass('prevent-scrolling')
      enableScrollLock()
    } 
    else {
//       $('body').removeClass('prevent-scrolling');
      disableScrollLock()
    }
  })
  

//   $(window).scroll(function() {
//     scroll = $(window).scrollTop();
//     if (scroll >= $('.announcement-bar').height()) {
//       $('.site-header').addClass("sticky");
//       $('#PageContainer').css('padding-top', $headerHeight);
//     } else {
//       $('.site-header').removeClass("sticky");
//       $('#PageContainer').css('padding-top', 0);          
//     }
//   });

function myFunction(x) {
  if (x.matches) { // If media query matches
    let sticked = false;
    $(window).scroll(function() {
      scroll = $(window).scrollTop();
      if (scroll >= $('.announcement-bar').height() && sticked == false) {
        $('.page-container').removeClass('trans');
        $('.site-header').addClass('sticky');
        $('#PageContainer').css('padding-top', $headerHeight);
        setTimeout(function() {
            $('.page-container').addClass('trans');      
        }, 100)
        sticked = true;
      } else if(scroll < $('.announcement-bar').height()) {
        $('.page-container').removeClass('trans');
        $('.site-header').removeClass("sticky");
        $('#PageContainer').css('padding-top', 0);          
        setTimeout(function() {
            $('.page-container').addClass('trans');      
        }, 100)
        sticked = false;
      }
    });
  }
}

var x = window.matchMedia("(min-width: 960px)")
myFunction(x) // Call listener function at run time
x.addListener(myFunction) // Attach listener function on state changes  
  
  
});
/****************/
/****************/

